import React from 'react';
import HeroSection from '../Components/HeroSection'; // adjust the path if needed
import ServicesSection from '../Components/Services';
import TechnologiesSection from '../Components/TechnologiesSection'

function App() {
  return (
    <div>
      <HeroSection/>
      <ServicesSection/>
      <TechnologiesSection/>
    </div>
  );
}

export default App;
